// Add class to body on homepage only
if (window.location.pathname === '/' || window.location.pathname === '') {
  document.body.classList.add('homepage');
}

// Optional: Add scroll effect
if (document.body.classList.contains('homepage')) {
  window.addEventListener('scroll', function() {
    const header = document.querySelector('.shopify-section-group-header-group');
    if (header) {
      if (window.pageYOffset > 100) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
    }
  });
}